import React, { useState } from "react";
import { Steps, Button, DatePicker, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { Header } from "../components";
import { fromDatetoYearMonthDay } from "../utils/utils";
import { assignDriverToOrders } from "../utils/fetchOrders";

import RouteStep1 from "../components/MakeRouteForm/RouteStep1";
import RouteStep2 from "../components/MakeRouteForm/RouteStep2";
import RouteStep3 from "../components/MakeRouteForm/RouteStep3";

const STEPS = [
  { title: "Seleccionar pedidos" },
  { title: "Eliminar duplicados" },
  { title: "Asignar choferes" },
];

const MakeRoute = () => {
  const navigate = useNavigate();

  const [routeDay, setRouteDay] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [isFinishing, setIsFinishing] = useState(false);

  const handleDateChange = (value) => {
    if (!value) return;
    setRouteDay(fromDatetoYearMonthDay(value.$d));
    setActiveStep(0);
    setSelectedOrders([]);
    setFilteredOrders([]);
  };

  const handleStep1Complete = (orders) => {
    setSelectedOrders(orders);
    setActiveStep(1);
  };

  const handleStep2Complete = (orders) => {
    setFilteredOrders(orders);
    setActiveStep(2);
  };

  const handleFinish = async (step3Data) => {
    setIsFinishing(true);
    try {
      await assignDriverToOrders(
        step3Data.groupData,
        step3Data.groupDataMayorista,
        step3Data.groupDataExternal,
        step3Data.data,
        step3Data.drivers,
        step3Data.ordersMinorista,
        step3Data.ordersMayorista,
        step3Data.ordersExternal,
        routeDay
      );
      navigate("/DashboardDailyRoute/" + routeDay, {
        state: { orders: step3Data.data },
      });
    } catch (error) {
      message.error(`Error al asignar choferes: ${error.message}`);
      console.error(error);
    } finally {
      setIsFinishing(false);
    }
  };

  return (
    <div className="bg-white dark:bg-main-dark-bg rounded-3xl p-6">
      <div className="mb-6 flex justify-between">
        <Header category="Aplicaciones" title="Hacer Ruta" />
      </div>

      {/* Date picker — always visible */}
      <div className="flex items-center gap-3 mb-8">
        <Typography.Text className="font-medium">Fecha de entrega:</Typography.Text>
        <DatePicker
          value={routeDay ? dayjs(routeDay) : null}
          onChange={handleDateChange}
          allowClear={false}
          placeholder="Selecciona una fecha"
        />
      </div>

      {routeDay && (
        <>
          <Steps
            current={activeStep}
            items={STEPS}
            className="mb-8"
          />

          {activeStep === 0 && (
            <RouteStep1 routeDay={routeDay} onComplete={handleStep1Complete} />
          )}

          {activeStep === 1 && (
            <RouteStep2
              orders={selectedOrders}
              routeDay={routeDay}
              onBack={() => setActiveStep(0)}
              onComplete={handleStep2Complete}
            />
          )}

          {activeStep === 2 && (
            <RouteStep3
              orders={filteredOrders}
              onBack={() => setActiveStep(1)}
              onComplete={handleFinish}
              isFinishing={isFinishing}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MakeRoute;
